import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto" }
const _hoisted_2 = {
  ref: "openseadragontoolbar",
  class: "mt-1"
}
const _hoisted_3 = { class: "inline-block w-full xl:w-1/3 xl:text-left text-right h-10" }
const _hoisted_4 = {
  class: "underline",
  id: "next"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = {
  class: "underline",
  id: "previous"
}
const _hoisted_7 = {
  ref: "openseadragon",
  id: "openseadragon",
  class: "bg-grey-dark h-80 md:h-800"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")!
  const _component_SmallButton = _resolveComponent("SmallButton")!
  const _component_FigureCaption = _resolveComponent("FigureCaption")!

  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ArrowIcon, {
          type: "back",
          width: 16,
          class: "black inline h-12"
        }),
        _createElementVNode("button", _hoisted_4, _toDisplayString(_ctx.$t('navigation.next')), 1),
        _hoisted_5,
        _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('navigation.previous')), 1),
        _createVNode(_component_ArrowIcon, {
          type: "forward",
          width: 12,
          class: "inline h-12"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('navigation.progress', {
            current: _ctx.currentImage + 1,
            total: _ctx.iiifJsonUrls.length,
          })), 1)
      ], 512), [
        [_vShow, _ctx.iiifJsonUrls.length > 1]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full h-10 text-right inline-block", _ctx.iiifJsonUrls.length > 1 ? 'xl:w-2/3' : ''])
      }, [
        _createVNode(_component_SmallButton, {
          class: "bg-blue-light mx-1",
          id: "zoom-in"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.zoom_in')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_SmallButton, {
          class: "bg-blue-light mx-1",
          id: "zoom-out"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.zoom_out')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_SmallButton, {
          class: "bg-blue-light mx-1",
          id: "full-page"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.fullscreen')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_SmallButton, {
          class: "bg-blue-light mx-1",
          id: "home"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.reset')), 1)
          ]),
          _: 1
        })
      ], 2)
    ], 512),
    _createElementVNode("div", _hoisted_7, null, 512),
    _createVNode(_component_FigureCaption, {
      imageCaption: _ctx.image_sources[_ctx.currentImage],
      imageCaptionLink: _ctx.image_links[_ctx.currentImage],
      largeCaption: true
    }, null, 8, ["imageCaption", "imageCaptionLink"])
  ]))
}